<div class="container mt-5">
  <!-- Header Section -->
  <div class="text-center mb-4">
    <!-- <h2 class="display-4 text-primary">GIS Map Editor</h2> -->
    </div>

  <!-- Button Group Section -->
  <div class="flex">
    <div class="col-12 col-sm-6 col-md-4 col-lg-2 mb-3">
      <button
     mat-button   (click)="addDrawInteraction('Point')"
        data-bs-toggle="tooltip" data-bs-placement="top" title="Draw Point"
      >
        <i class="bi bi-pin-fill me-2"></i> Draw Point
      </button>
    </div>

    <div class="col-12 col-sm-6 col-md-4 col-lg-2 mb-3">
      <button mat-button
        (click)="addDrawInteraction('LineString')"
        data-bs-toggle="tooltip" data-bs-placement="top" title="Draw Line"
      >
        <i class="bi bi-pencil-fill me-2"></i> Draw Line
      </button>
    </div>

    <div class="col-12 col-sm-6 col-md-4 col-lg-2 mb-3">
      <button
      mat-button
      (click)="addDrawInteraction('Polygon')"
        data-bs-toggle="tooltip" data-bs-placement="top" title="Draw Polygon"
      >
        <i class="bi bi-caret-down-fill me-2"></i> Draw Polygon
      </button>
    </div>

    <div class="col-12 col-sm-6 col-md-4 col-lg-2 mb-3">
      <button mat-button
        (click)="loadGeoJSON()"
        data-bs-toggle="tooltip" data-bs-placement="top" title="Load Data from GeoServer"
      >
        <i class="bi bi-cloud-arrow-down-fill me-2"></i> Load GeoJSON
      </button>
    </div>

    <div class="col-12 col-sm-6 col-md-4 col-lg-2 mb-3">
      <button
      mat-button  
      class="btn btn-success w-100 d-flex justify-content-center align-items-center"
        (click)="saveGeoJSON()"
        data-bs-toggle="tooltip" data-bs-placement="top" title="Save Data to GeoServer"
      >
        <i class="bi bi-cloud-arrow-up-fill me-2"></i> Save to GeoServer
      </button>
    </div>
  </div>
</div>
  <div id="map" class="map-container"></div>
  